<template>
  <div class="itinerary-view">
    <itinerary-summary
      :itinerary="itinerary"
      :fromPlace="fromPlace"
      :toPlace="toPlace"
      v-if="fromPlace && toPlace"
    />
    <div
      class="no-trip"
      v-else
    >{{loadingItinerary ? "Henter rute ..." : "Der er ikke oprettet en returrute"}}
    </div>
    <div class="itineraries-bg">
      <CurrentItinerary
        :viewMode="true"
        v-if="itinerary"
        :itinerary="itinerary"
        :fromPlace="fromPlace"
        :toPlace="toPlace"
      />
    </div>
    <a
      href="http://www.septima.dk"
      target="_blank"
      class="septima-logo"
    >
      <SeptimaLogo :iconColor="'#101B70'" /></a>
  </div>
</template>

<script>
import CurrentItinerary from '@/components/Itinerary/CurrentItinerary';
import ItinerarySummary from '@/components/Itinerary/ItinerarySummary';
import SeptimaLogo from '@/components/Icons/SeptimaLogo.vue';
export default {
  name: 'itinerary-view',
  components: {
    CurrentItinerary,
    ItinerarySummary,
    SeptimaLogo,
  },
  props: {
    itinerary: Object,
    fromPlace: Object,
    toPlace: Object,
    loadingItinerary: Boolean,
  },
  computed: {
    startTime() {
      if (!this.itinerary) {
        return undefined;
      }
      return new Date(this.itinerary.startTime).toISOString();
    },
  },
};
</script>

<style lang="scss" scoped>
.itinerary-view {
  flex-grow: 1;
  flex-basis: 0;
  background-color: $primary-100;
  margin-right: 2px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // display: flex;
  // flex-direction: column;
}

.itineraries-bg,
.no-trip {
  // flex: 1;
  padding: 45px 80px 30px 80px;
}

.septima-logo {
  opacity: 0.3;
  align-self: center;
  padding: 20px 0;
  display: flex;
  justify-content: space-around;
  margin-top: auto;
}

@media only screen and (max-width: $tablet-landscape-max-width) {
  .itinerary-view {
    width: 100%;
    height: 100%;
    // min-height: 100%;

    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    margin-right: 0;
  }
  .itineraries-bg {
    padding: 25px 80px;
  }

  .no-trip {
    padding: 30px 80px;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  .itineraries-bg {
    padding: 0 30px;
  }

  .no-trip {
    padding: 30px;
  }

  .septima-logo {
    padding: 30px 0;
  }
}
</style>
